<template>
  <button class="icon sign-out-button" :class="{destructive: loggingOut}" @click="clicked" ref="button">
    <v-icon name="log-out"></v-icon>
  </button>
</template>
<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'signOutButton',
    data () {
      return {
        loggingOut: false
      }
    },
    methods: {
      ...mapActions(['userSignOut']),
      clicked () {
        if (!this.loggingOut)
          this.loggingOut = true
        else {
          this.userSignOut()
          this.loggingOut = false
        }
      }
    },
    mounted () {
      window.addEventListener('click', event => {
        if (this.loggingOut && event.target !== this.$refs['button'])
          this.loggingOut = false
      })
    }
  }
</script>
<style scoped lang="sass">
  .sign-out-button
    min-width: unset
    transition: $transition-quick
    transform: scaleX(-1)
</style>
